import { render, staticRenderFns } from "./DirectoryPath.vue?vue&type=template&id=1889d81a&scoped=true&"
import script from "./DirectoryPath.vue?vue&type=script&lang=js&"
export * from "./DirectoryPath.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryPath.css?vue&type=style&index=0&id=1889d81a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889d81a",
  null
  
)

export default component.exports